import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import DoctorCard from "../Components/DoctorCard";
import profile1 from "../Assets/profile-1.png";
import profile2 from "../Assets/profile-2.png";
import "../Styles/Doctors.css";

function Doctors() {
  return (
    <>
      <Navbar />
      <div className="doctor-section" id="doctors">
        <div className="dt-title-content">
          <h3 className="dt-title">
            <span>Meet Our Doctors</span>
          </h3>

          <p className="dt-description">
            Meet our exceptional team of specialist neurologists, dedicated to
            providing top-notch neurological care services at NeuroCare Clinic. Trust in their
            knowledge and experience to lead you towards a healthier brain and nervous system.
          </p>
        </div>

      
           <div className="dt-cards-content">
        <DoctorCard
          img={profile1}
          name="Dr. Bagadi Suneel Kumar"
          title="Neuro Physician"
          bio="Expert in headaches, seizures and neuromuscular disorders with 15+ years of clinical experience."
          stars="4.9"
          reviews="1800"
          contact="#"
          profileLink="#"
        />
           <DoctorCard
          img={profile2}
          name="Dr. Pydi Venu Madhavi"
          title="Endocrinologist"
          bio="Specializes in diabetes, thyroid disorders, and hormonal therapies with a patient-centred approach."
          stars="4.7"
          reviews="450"
          contact="#"
          profileLink="#"
        />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Doctors;
